var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmericanFootball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m496.955 51.045-20.481-42.956c-9.083-4.876-19.426-7.728-30.432-7.957-40.205-.839-79.133 2.321-116.194 9.598l-48.696 12.292c-61.73 19.25-116.917 51.286-162.381 96.75-45.477 45.478-77.518 100.686-96.766 162.438l-12.288 48.707c-7.268 37.04-10.423 75.945-9.585 116.125.23 11.001 3.078 21.339 7.95 30.419l42.963 20.494c128.619 2.684 244.184-35.553 327.27-118.64 83.087-83.087 121.324-198.651 118.64-327.27z",
    fill: "#966a5b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m353.324 170.355-182.97 182.97c-3.228 3.228-8.454 3.225-11.679 0s-3.228-8.451 0-11.679l182.97-182.97c3.228-3.228 8.454-3.225 11.679 0s3.228 8.451 0 11.679z",
    fill: "#f4dbb3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m345.7 223.724c-3.228 3.228-8.454 3.225-11.679 0l-45.745-45.745c-3.225-3.225-3.228-8.451 0-11.679s8.454-3.225 11.679 0l45.745 45.745c3.225 3.225 3.227 8.451 0 11.679z",
    fill: "#faf5dc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m315.209 254.215c-3.228 3.228-8.454 3.225-11.679 0l-45.745-45.745c-3.225-3.225-3.228-8.451 0-11.679s8.454-3.225 11.679 0l45.745 45.745c3.225 3.225 3.227 8.452 0 11.679z",
    fill: "#faf5dc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m284.712 284.712c-3.228 3.228-8.454 3.225-11.679 0l-45.745-45.745c-3.225-3.225-3.228-8.451 0-11.679s8.454-3.225 11.679 0l45.745 45.745c3.225 3.225 3.228 8.451 0 11.679z",
    fill: "#faf5dc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m254.215 315.209c-3.228 3.228-8.454 3.225-11.679 0l-45.745-45.745c-3.225-3.225-3.228-8.451 0-11.679s8.454-3.225 11.679 0l45.745 45.745c3.225 3.225 3.228 8.451 0 11.679z",
    fill: "#faf5dc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m223.724 345.7c-3.228 3.228-8.454 3.225-11.679 0l-45.745-45.745c-3.225-3.225-3.228-8.451 0-11.679s8.454-3.225 11.679 0l45.745 45.745c3.225 3.225 3.228 8.451 0 11.679z",
    fill: "#faf5dc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m511.868 65.958c-.524-25.089-14.696-46.745-35.394-57.868 8.081 137.999-29.44 262.719-117.553 350.833-88.113 88.113-212.841 125.62-350.84 117.539 11.124 20.698 32.787 34.884 57.875 35.407 40.18.838 79.086-2.317 116.126-9.585l48.705-12.287c61.753-19.249 116.961-51.29 162.44-96.768 45.463-45.463 77.498-100.65 96.749-162.379l12.296-48.715c7.277-37.056 10.435-75.979 9.596-116.177z",
    fill: "#785353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.002 281.21c-4.928 15.812-9.024 32.09-12.285 48.707l137.943 137.941 39.466 4.517 9.289-16.753z",
    fill: "#faf5dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467.87 147.751-138.022-138.023c-16.617 3.261-32.881 7.37-48.693 12.297l174.437 174.437 20.158-7.213z",
    fill: "#faf5dc"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f4dbb3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m147.659 467.858 34.424 34.424c16.617-3.261 32.893-7.358 48.705-12.286l-34.375-34.375c-15.838 4.924-32.109 8.985-48.754 12.237z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.592 196.463 34.386 34.386c4.928-15.812 9.034-32.098 12.295-48.715l-34.401-34.381c-3.254 16.642-7.355 32.874-12.28 48.71z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanFootball);
export default __webpack_public_path__ + "static/media/american-football.0fc0c67040469fdf46bf13c7c054ed39.svg";
export { ForwardRef as ReactComponent };